import React from "react";
import { FormProvider } from "react-hook-form";
import {
  Alert,
  Box,
  Stack,
} from "@mui/material";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import {
  RFHAutocomplete,
  RFHTextField,
  RHFRadioGroup,
} from "../../../../components/RFH";
import { CustomButton } from "../../../../components/Button/Button";
import { inviteUserTypes } from "../../../../utils/constants/index.js";
import { useInviteUserForm } from "../hooks/useInviteUserForm";

function InviteUserForm({ onClose, onOpenUploadUserCSV }) {
  const {
    apiError,
    tab,
    loading,
    userOptions,
    formMethods,
    handleSubmit,
    submit,
  } = useInviteUserForm({ onClose });
  const { ...methods } = formMethods;

  return (
    <FormProvider {...methods}>
      <Box
        component="form"
        onSubmit={handleSubmit(submit)}
        noValidate
        className="invite-user-form"
      >
        <Box className="invite-user-form-selection-row">
          <RHFRadioGroup
            name="tab"
            row={true}
            options={inviteUserTypes}
            isCircularRadio={true}
            className="invite-user-form-radio-group"
          />
          <Box
            className="invite-user-form-csv-trigger"
            onClick={onOpenUploadUserCSV}
            onKeyDown={(event) => {
              if (event.key === "Enter" || event.key === " ") {
                event.preventDefault();
                onOpenUploadUserCSV();
              }
            }}
            role="button"
            tabIndex={loading ? -1 : 0}
            aria-disabled={loading}
          >
            <RadioButtonUncheckedIcon />
            <span>Upload CSV File</span>
          </Box>
        </Box>

        <Stack spacing={3} mt={2}>
          {apiError && <Alert severity="error">{apiError}</Alert>}

          {tab === "internalUser" ? (
            <Stack spacing={1}>
              <RFHAutocomplete
                name="user"
                label={"Select User"}
              options={userOptions}/>
            </Stack>
          ) : (
            <Stack spacing={3}>
              <RFHTextField
                name="first_name"
                label={"First Name"}
                required
                fullWidth
                className="invite-user-form-text-field"
              />

              <RFHTextField
                name="last_name"
                label={"Last Name"}
                required
                fullWidth
                className="invite-user-form-text-field"
              />

              <RFHTextField
                name="email"
                label={"Email Address"}
                required
                fullWidth
                className="invite-user-form-text-field"
              />
            </Stack>
          )}
          <Box
            sx={{
              alignSelf: "end",
            }}
            className="invite-user-form-button-container d-flex"
          >
            <CustomButton
              type="submit"
              variant="contained"
              className="invite-user-form-submit-button"
              disabled={loading}
            >
              Add
            </CustomButton>
            <CustomButton
              variant="outlined"
              className="invite-user-form-cancel-button"
              onClick={onClose}
              disabled={loading}
            >
              Cancel
            </CustomButton>
          </Box>
        </Stack>
      </Box>
    </FormProvider>
  );
}

export default React.memo(InviteUserForm);
